import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";

if ("serviceWorker" in navigator && import.meta.env.PROD) {
  window.addEventListener("load", () => void navigator.serviceWorker.register("/sw.js"));
}

const previewData =
  import.meta.env.DEV && new URLSearchParams(window.location.search).has("preview")
    ? (await import("./preview")).previewData
    : undefined;

createRoot(document.getElementById("root") as HTMLElement).render(
  <StrictMode>
    <App {...(previewData ? { previewData } : {})} />
  </StrictMode>,
);
